/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { IndividualPaymentParcelDetailViewModel } from "../types/IndividualPaymentParcelDetailViewModel.ts";

export const individualPaymentParcelDetailViewModelSchema = z.object({
  id: z.optional(z.number().int()),
  courseFinancialPersonId: z.optional(z.number().int()),
  numberParcel: z.optional(z.number().int()),
  typeId: z.optional(z.number().int()),
  statusId: z.optional(z.number().int()),
  paymentMethod: z.optional(z.number().int()),
  total: z.optional(z.number()),
  expirationDate: z.optional(z.string().datetime()),
  fine: z.number().nullish(),
  discountPunctualPercentage: z.number().nullish(),
  totalDiscount: z.optional(z.number()),
  retroactiveDiscount: z.optional(z.number()),
  observation: z.string().nullish(),
  message: z.string().nullish(),
  invoiceNumber: z.string().nullish(),
  invoiceIssueDate: z.string().datetime().nullish(),
  serial: z.number().int().nullish(),
  fractionOfParcel: z.number().nullish(),
  typeText: z.string().nullish(),
  statusText: z.string().nullish(),
  paymentMethodText: z.string().nullish(),
  isPaid: z.optional(z.boolean()),
  totalPaid: z.number().nullish(),
  paymentDate: z.string().datetime().nullish(),
  refundDate: z.string().datetime().nullish(),
  refundValue: z.number().nullish(),
  extendedExpirationDate: z.string().datetime().nullish(),
  extendedExpirationProcessDate: z.string().datetime().nullish(),
  integrationDate: z.string().datetime().nullish(),
  enotasIntegrationDate: z.string().datetime().nullish(),
  nfeFileName: z.string().nullish(),
  userCreation: z.string().nullish(),
  creationDate: z.string().datetime().nullish(),
  userLastChange: z.string().nullish(),
  lastChangeDate: z.string().datetime().nullish(),
}) as unknown as ToZod<IndividualPaymentParcelDetailViewModel>;
